export default [
  {
    title: 'Catalog',
    icon: { icon: 'lucide:package' },
    action: 'read',
    subject: 'User',
    envOnly: 'development',
    children: [
      {
        title: 'Products',
        to: 'catalog-products',
        icon: { icon: 'lucide:boxes' },
        action: 'read',
        subject: 'User',
        envOnly: 'development',
      },
      {
        title: 'Suggestions',
        to: 'catalog-suggestions',
        icon: { icon: 'lucide:git-merge' },
        action: 'read',
        subject: 'User',
        envOnly: 'development',
      },
      {
        title: 'Locations',
        to: 'catalog-locations',
        icon: { icon: 'lucide:map-pin' },
        action: 'read',
        subject: 'User',
        envOnly: 'development',
      },
      {
        title: 'Suppliers',
        to: 'catalog-suppliers',
        icon: { icon: 'lucide:truck' },
        action: 'read',
        subject: 'User',
        envOnly: 'development',
      },
      {
        title: 'Purchase orders',
        to: 'catalog-purchase-orders',
        icon: { icon: 'lucide:clipboard-list' },
        action: 'read',
        subject: 'User',
        envOnly: 'development',
      },
      {
        title: 'Transfers',
        to: 'catalog-transfers',
        icon: { icon: 'lucide:arrow-right-left' },
        action: 'read',
        subject: 'User',
        envOnly: 'development',
      },
      {
        title: 'Stock',
        to: 'catalog-stock',
        icon: { icon: 'lucide:warehouse' },
        action: 'read',
        subject: 'User',
        envOnly: 'development',
      },
      {
        title: 'Cost',
        to: 'catalog-cost',
        icon: { icon: 'lucide:coins' },
        action: 'read',
        subject: 'User',
        envOnly: 'development',
      },
      {
        title: 'Periods',
        to: 'catalog-periods',
        icon: { icon: 'lucide:calendar-range' },
        action: 'read',
        subject: 'User',
        envOnly: 'development',
      },
      {
        title: 'Stock overview',
        to: 'catalog-stock-overview',
        icon: { icon: 'lucide:warehouse' },
        action: 'read',
        subject: 'User',
        envOnly: 'development',
      },
      {
        title: 'Valuation',
        to: 'catalog-valuation',
        icon: { icon: 'lucide:chart-no-axes-combined' },
        action: 'read',
        subject: 'User',
        envOnly: 'development',
      },
      {
        title: 'Cost history',
        to: 'catalog-cost-history',
        icon: { icon: 'lucide:history' },
        action: 'read',
        subject: 'User',
        envOnly: 'development',
      },
    ],
  },
];
